import { DatePipe } from '@angular/common';
import { Injector, Pipe, PipeTransform } from '@angular/core';
import { PipeDefinitionModel } from '../models/column-definition.model';
import { BooleanPipe } from './boolean.pipe';
import { NullableBooleanPipe } from './nullable-boolean.pipe';
import { MoneyPipe } from './money.pipe';
import { DelayPipe } from './delay.pipe';
import { InvoiceStatePipe } from './invoice-state.pipe';
import { JoinListPipe } from './join-list.pipe';
import { ActivityOperation } from './activity-operation.pipe';
import { ActivityDomaine } from './activity-domaine.pipe';
import * as _ from 'lodash';
@Pipe({
  name: 'dynamic',
})
export class DynamicPipe implements PipeTransform {
  pipeMapper = {
    booleanPipe: BooleanPipe,
    nullableBooleanPipe: NullableBooleanPipe,
    moneyPipe: MoneyPipe,
    datePipe: DatePipe,
    delayPipe: DelayPipe,
    statePipe: InvoiceStatePipe,
    joinListPipe: JoinListPipe,
    activityOperation: ActivityOperation,
    activityDomaine: ActivityDomaine,
  };

  public constructor(private injector: Injector) {}

  transform(value: any, param: any, pipeDefinition: PipeDefinitionModel): any {
    if (!pipeDefinition) {
      return value;
    } else {
      const pipeClass = this.pipeMapper[pipeDefinition.PipeName];
      if (_.isNil(pipeClass)) {
        return value;
      }
      let pipe = this.injector.get<PipeTransform>(pipeClass);
      return pipe.transform(value, pipeDefinition.PipeArgs, param);
    }
  }
}
